import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import CloudDownloadTwoToneIcon from '@mui/icons-material/CloudDownloadTwoTone';

import { Button } from '../../../components'
import { downloadAction } from '../../../utils/actions'
import { concatClasses } from '../../../utils/fns'

const GlobalDownload = (props) => {
  const { className, disabled, onClick } = props
  const dispatch = useDispatch()

  const handleDownloadAction = () => {
    dispatch(downloadAction())
  }

  return (
    <Button
      variant="topNav"
      className={concatClasses('button topNav__button -download', className)}
      disabled={disabled}
      onClick={onClick ?? handleDownloadAction}
    >
      <CloudDownloadTwoToneIcon className='material-icons-two-tone' />
      <span className="button__text">Download</span>
    </Button>
  )
}

GlobalDownload.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default memo(GlobalDownload)
